export default {"src":"/_next/static/media/forest.6fe644f3.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};